import ApiAdmin from "@/services/apiAdmin.service";
import {
  FETCH_ALL_ROYALTIES_RELATORIO,
  FETCH_ALL_USO_COBRANCAS
} from "@/store/actions/actions.type";
import {
  SET_ALL_RELATORIO_PAGAMENTOS_POR_USO,
  SET_ALL_ROYALTIES_RELATORIO,
  FETCH_RELATORIO_END,
  FETCH_RELATORIO_START
} from "@/store/mutations/mutations.type";
const state = {
  royaltiesRelatorio: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  },
  relatorioUsoCobrancas: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  },
  isFetchingRelatorio: false
};
const getters = {
  isFetchingRelatorio(state) {
    return state.isFetchingRelatorio;
  },
  royaltiesRelatorio(state) {
    return state.royaltiesRelatorio;
  },
  relatorioUsoCobrancas(state) {
    return state.relatorioUsoCobrancas;
  }
};

const actions = {
  [FETCH_ALL_ROYALTIES_RELATORIO](context, params) {
    context.commit(FETCH_RELATORIO_START);
    return new Promise((resolve, reject) => {
      ApiAdmin.query("relatorios/royalties", params)
        .then(response => {
          context.commit(SET_ALL_ROYALTIES_RELATORIO, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_RELATORIO_END);
        });
    });
  },
  [FETCH_ALL_USO_COBRANCAS](context, params) {
    context.commit(FETCH_RELATORIO_START);
    return new Promise((resolve, reject) => {
      ApiAdmin.query("relatorios/uso-mensal", params)
        .then(response => {
          context.commit(SET_ALL_RELATORIO_PAGAMENTOS_POR_USO, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_RELATORIO_END);
        });
    });
  }
};

const mutations = {
  [SET_ALL_RELATORIO_PAGAMENTOS_POR_USO](state, relatorioUsoCobrancas) {
    state.relatorioUsoCobrancas = relatorioUsoCobrancas;
  },
  [SET_ALL_ROYALTIES_RELATORIO](state, royaltiesRelatorio) {
    state.royaltiesRelatorio = royaltiesRelatorio;
  },
  [FETCH_RELATORIO_START](state) {
    state.isFetchingRelatorio = true;
  },
  [FETCH_RELATORIO_END](state) {
    state.isFetchingRelatorio = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
